import { getLocale } from "../runtime";

const sv_continuetoshop = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Fortsätt till butik`
};

const continuetoshop = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_continuetoshop(inputs)
	return "continueToShop";
};

export { continuetoshop as "continueToShop" };